import React from "react";
import MainContainer from "../../components/atoms/MainContainer";
import MainContentContainer from "../../components/atoms/MainContentContainer";

import Logo from "../../components/molecures/Logo";
import LoginForm from "./components/LoginForm";

const Login: React.FC = () => {
  return (
    <MainContainer>
      <Logo />
      <MainContentContainer>
        <LoginForm />
      </MainContentContainer>
    </MainContainer>
  );
};
export default Login;
